import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

// Un compte n'ayant que le rôle MAIL_OPERATOR (voir AuthService.isMailOperatorOnly) ne doit
// avoir accès qu'à l'écran de configuration mail — tout le reste de l'admin redirige dessus.
const MAIL_OPERATOR_ALLOWED_PREFIX = '/admin/settings/mail-configs';

export const mailOperatorRestrictionGuard: CanActivateChildFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.ensureRolesLoaded().pipe(
    map(() => {
      if (!authService.isMailOperatorOnly()) return true;
      if (state.url.startsWith(MAIL_OPERATOR_ALLOWED_PREFIX)) return true;
      return router.createUrlTree(['/admin/settings/mail-configs']);
    }),
    // Si le chargement des rôles échoue (session invalide, requête rejetée...), la navigation
    // ne doit jamais rester bloquée silencieusement — on refuse et on renvoie au login.
    catchError(() => of(router.createUrlTree(['/auth/login'])))
  );
};
